export const TX_TYPES = {
  EXCHANGE: 'exchange',
  FIAT: 'fiat',
  RECEIVED: 'rx',
  SENT: 'tx',
  APPROVAL: 'approval',
  CLEANUP: 'cleanup',
  NFT: 'nft',
}
